<template>
    <div>
      
               <div class="form-row position-relative">
           
            <div class="position-absolute text-right d-block more-options-menu" v-on:mouseover="hover=true"   v-on:mouseleave="hover = false" v-if="!readOnly && (!first || last)">
                <ul class="list-inline p-1">
                    <li class="list-inline-item text-center" v-if="hover && last">
                        <a v-on:click="add" title="Aggiungi nuovo numero telefonico" >
                            <font-awesome-icon icon="plus"></font-awesome-icon>
                        </a>
                    </li>
                    <li class="list-inline-item text-center"  v-if="hover && !first">
                        <a v-on:click="remove" title="Rimuovi numero telefonico" class="text-danger">
                            <font-awesome-icon icon="times"></font-awesome-icon>
                        </a>
                    </li>
                    <li class="list-inline-item text-center"  v-if="!hover">
                        <a  class="text-mute">
                            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                        </a>
                    </li>

                </ul>
            </div>
            <label class="col-12 col-form-label d-relative" :for="value.phoneId">
                 <editable-label :label="value.label" @update-label="upddateLabel" :index="index" defaultLabel="Numero telefonico"  :readOnly="readOnly"></editable-label>
            </label>
            <div class="col">
             
                    <input type="text" :id="value.phoneId" v-if="!readOnly" :name="value.phoneId" placeholder="Numero telefonico" v-model="value.phoneNumber" class="form-control" >
               
                <span v-if="readOnly">
                    {{value.phoneNumber}}
                </span>
              
            </div>
        </div>
           
          
        </div>

       

</template>
<script>

export default {
        name: 'phone',
       
        props: {
            readOnly: {
                type: Boolean,
                required: false,
                default:() => false
            },
             last: {
                type: Boolean,
                required: true,
                default:() => false
            },
              first: {
                type: Boolean,
                required: false,
                default:() => false
            },
            value: {
                type: Object,
                required: false,
                
            },
            index: {
                type: Number,
                required: false,
                default:()=>0
            }
        },
      
        components: {
           
        },
        data() {
            return {
                hover:false
            }
        },
        methods: {
            
         
            upddateLabel: function (label) {
                this.value.label = label;
            }
           
             , remove: function () {
                this.$emit('remove-entity', this.value)
            }

              , add: function () {
               
               
                 this.$emit('add-entity')
            }
            
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
